"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxModeRoute = void 0;
var InfoBoxModeRoute;
(function (InfoBoxModeRoute) {
    InfoBoxModeRoute["Arteries"] = "arteries";
    InfoBoxModeRoute["Branches"] = "branches";
    InfoBoxModeRoute["Craniometrics"] = "craniometrics";
    InfoBoxModeRoute["CrossSections"] = "cross-sections";
    InfoBoxModeRoute["Drainage"] = "drainage-trace";
    InfoBoxModeRoute["Isolate"] = "isolate";
    InfoBoxModeRoute["Landmarks"] = "landmarks";
    InfoBoxModeRoute["Motion"] = "motion";
    InfoBoxModeRoute["MultiselectFocus"] = "multiselect-focus";
    InfoBoxModeRoute["MuscleOI"] = "oi";
    InfoBoxModeRoute["Nerves"] = "nerves";
    InfoBoxModeRoute["Origin"] = "origin-path";
    InfoBoxModeRoute["Parts"] = "parts";
    InfoBoxModeRoute["Surfaces"] = "surfaces";
    InfoBoxModeRoute["Sutures"] = "sutures";
    InfoBoxModeRoute["Tributaries"] = "tributaries-trace";
})(InfoBoxModeRoute || (exports.InfoBoxModeRoute = InfoBoxModeRoute = {}));
